import { Modal } from "react-bootstrap";
import closeIcon from "../assets/images/closeIcon.svg";
import thumbsup from "../assets/images/thumbs-up.svg";
import activeThumsUp from "../assets/images/activeThumsUp.svg";
import thumbsdown from "../assets/images/thumbs-down.svg";
import activethumpsdown from "../assets/images/thumbsdownWhitediff.svg";
import arrowright from "../assets/images/arrow-right.svg";
import Cautious from "../assets/images/Cautious.svg";
import Satisfied from "../assets/images/satisfied.svg";
function SkipQuestions(props) {

    const { show, handlceClose, handleSkip, skipTo,
        setSkipToNo, setSelectedNumber } = props
    return (
        <Modal show={show} size="md" centered>




            <Modal.Body className="modal-body-sx pt-3">
                {/* Instructions */}


                {/* Cards Section */}
                <div className="ARW-sec" >
                    <h5 style={{ fontFamily: "Inter-Regular", textAlign: "center" }}>Please select one Most Relatable and one Least relatable word in each set.</h5>

                    <div className="ARW-box-wrap " style={{ justifyContent: 'center' }}>
                        <div style={{ display: "flex", flexDirection: "column" }}>
                            {/* Row 1 */}
                            <div className="card-sx-wrap d-flex justify-content-center">
                                <div className="card-sx" style={{ border: "1px solid #ccc" }}>
                                    <div className="card-inside-wrap">
                                        <img src={Cautious} className="card-img-sx" alt="Card" />
                                        <div>
                                            <p style={{ fontFamily: "Inter-Regular" }}>Daring</p>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: 8,
                                                    justifyContent: "flex-end",
                                                }}
                                            >
                                                <img
                                                    src={thumbsdown}
                                                    className="thumbsdown-box thumbsup-box-actv "
                                                    alt="Thumbs Down"
                                                    style={{ cursor: "pointer" }}
                                                />
                                                <img
                                                    src={activeThumsUp}
                                                    className="thumbsup-box-actv "
                                                    alt="Thumbs Up"
                                                    style={{ cursor: "pointer" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="card-sx" style={{ border: "1px solid #ccc", marginTop: '-5px' }}>
                                    <div className="card-inside-wrap">
                                        <img src={Satisfied} className="card-img-sx" alt="Card" />
                                        <div>
                                            <p style={{ fontFamily: "Inter-Regular" }}>Satisfied</p>
                                            <div
                                                style={{
                                                    display: "flex",
                                                    gap: 8,
                                                    justifyContent: "flex-end",
                                                }}
                                            >
                                                <img
                                                    src={activethumpsdown}
                                                    className="thumbsdown-box-actv"
                                                    alt="Thumbs Down"
                                                    style={{ cursor: "pointer" }}
                                                />
                                                <img
                                                    src={thumbsup}
                                                    className="thumbsup-box"
                                                    alt="Thumbs Up"
                                                    style={{ cursor: "pointer" }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Row 2 */}

                        </div>


                    </div>
                    <div className="d-flex justify-content-end gap-1" >
                        <button
                            className="comp-nxtbtn px-3 ms-0 comp-nxtbtnWhite "
                            onClick={() => {

                                if (skipTo) {

                                    setSelectedNumber(Number(skipTo))
                                    setSkipToNo(null)
                                } else {
                                    handleSkip()
                                }
                                handlceClose()
                            }}
                        >
                            Skip
                        </button>
                        <button
                            className="comp-nxtbtn px-3 ms-0"
                            onClick={handlceClose}

                        >
                            Return
                        </button>

                    </div>
                </div>

            </Modal.Body>


        </Modal >
    );
}

export default SkipQuestions;
